const getWishlistSkus = (items) => {
  return items?.map((item) => item.sku) ?? [];
};
export {
  getWishlistSkus
};
//# sourceMappingURL=get-wishlist-skus.js.map
